import { render } from "./RobotsView.vue?vue&type=template&id=c52584d0&scoped=true"
import script from "./RobotsView.vue?vue&type=script&lang=js"
export * from "./RobotsView.vue?vue&type=script&lang=js"

import "./RobotsView.vue?vue&type=style&index=0&id=c52584d0&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c52584d0"]])

export default __exports__